export interface NavigationCloseEntityOptions {
    passed: boolean
    entityName?: string
}

export type NavigationModalOptions =
    | { type: "created" }
    | { type: "edited" }
    | { type: "deleted"; entityName: string };

export interface NavigationDeleteEntityOptions {
    deleted: boolean
    entityName?: string
}

/**
 * Reset a record-based form data.
 *
 * @param setState - The state setter function to update the form data state.
 */
export const resetRecordFormData = (setState: React.Dispatch<React.SetStateAction<Record<string, string>>>) => {
    setState((prevState: Record<string, string>) => {
        const emptyState = Object.fromEntries(Object.keys(prevState).map((key: string) => [key, ""])) as Record<string, string>
        return emptyState
    })
}

export const handleUploadFileClick = (
    accept: string,
    setSelectedFile: React.Dispatch<React.SetStateAction<File | null>>,
    setFormData: React.Dispatch<React.SetStateAction<Record<string, string>>>,
    setFormErrors: React.Dispatch<React.SetStateAction<Record<string, string>>> | null,
    formProperty: string,
) => {
    try {
        const fileInput = document.createElement("input")
        fileInput.type = "file"
        fileInput.accept = accept
        fileInput.addEventListener("change", event => {
            const file = (event.target as HTMLInputElement).files?.[0] || null
            setSelectedFile(file)
            setFormData(prevData => ({
                ...prevData,
                [formProperty]: file ? file.name : "", // Dynamically set the form property
            }))
            if (setFormErrors) {
                setFormErrors(prevData => ({
                    ...prevData,
                    [formProperty]: "", // Dynamically set the error property
                }))
            }
        })
        fileInput.click()
    } catch (e) {
        console.log(e)
        setFormData(prevData => ({
            ...prevData,
            [formProperty]: "",
        }))
    }
}
